import { Song } from '@core/api/entities/song/song'

import { SegmentStat } from './segmentStat'

export class Segment {
	public id: number
	public description: string
	public startAt: string
	public endAt: string
	public priority: number
	public options: SegmentOptions | null
	public type: string
	public crossfade: number
	public mirrorId: number | null
	public rotateAutomatically: boolean
	public songsCount: number
	public size: number
	public size2: number
	public size3: number
	public length: number
	public artists: string[]
	public dirtyAnalytics: boolean
	public totalGeneratedSongs: number
	public droppedSongs: string[]
	public feedbackDropRatio: number

	public stats: SegmentStat[]
	public songs?: Song[]

	constructor(data: {
		id: number
		description: string
		startAt: string
		endAt: string
		priority: number
		options: SegmentOptions | null
		type: string
		crossfade: number
		mirrorId: number | null
		rotateAutomatically: boolean
		songsCount: number
		size: number
		size2: number
		size3: number
		length: number
		artists: string[]
		dirtyAnalytics: boolean
		totalGeneratedSongs: number
		droppedSongs: string[]
		feedbackDropRatio: number
		stats: SegmentStat[]
		songs?: Song[]
	}) {
		this.id = data.id
		this.description = data.description
		this.startAt = data.startAt
		this.endAt = data.endAt
		this.priority = data.priority
		this.options = data.options
		this.type = data.type
		this.crossfade = data.crossfade
		this.mirrorId = data.mirrorId
		this.rotateAutomatically = data.rotateAutomatically
		this.songsCount = data.songsCount
		this.size = data.size
		this.size2 = data.size2
		this.size3 = data.size3
		this.length = data.length
		this.artists = data.artists
		this.dirtyAnalytics = data.dirtyAnalytics
		this.totalGeneratedSongs = data.totalGeneratedSongs
		this.droppedSongs = data.droppedSongs
		this.feedbackDropRatio = data.feedbackDropRatio
		this.stats = data.stats
		this.songs = data.songs
	}

	static create(data: Partial<Segment>) {
		const defaultData = {
			id: 0,
			description: '',
			startAt: '',
			endAt: '',
			priority: 0,
			options: SegmentOptions.create({}),
			type: '',
			crossfade: 0,
			mirrorId: null,
			rotateAutomatically: false,
			songsCount: 0,
			size: 0,
			size2: 0,
			size3: 0,
			length: 0,
			artists: [],
			dirtyAnalytics: false,
			totalGeneratedSongs: 0,
			droppedSongs: [],
			feedbackDropRatio: 0,
			stats: [],
			songs: undefined,
		}

		return new Segment({
			...defaultData,
			...data,
		})
	}
}

export class SegmentOptions {
	public days: number[] | null
	public volume: number | null

	constructor(data: { days: number[] | null; volume: number | null }) {
		this.days = data.days
		this.volume = data.volume
	}

	static create(data: Partial<SegmentOptions>) {
		const defaultData = {
			days: null,
			volume: null,
		}

		return new SegmentOptions({
			...defaultData,
			...data,
		})
	}
}
